import { Component, inject, OnInit } from "@angular/core";
import { NandaChatComponent } from "../nanda-chat/nanda-chat.component";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import {
    MAT_BOTTOM_SHEET_DATA,
    MatBottomSheetRef
} from "@angular/material/bottom-sheet";
import { CompanyEntity, ReportEntity } from "@arch/domain/entity";

@Component({
    selector: "app-nanda-sheet",
    imports: [NandaChatComponent, SharedMaterialModule],
    templateUrl: "./nanda-sheet.component.html",
    styleUrl: "./nanda-sheet.component.scss"
})
export class NandaSheetComponent implements OnInit {
    readonly data = inject(MAT_BOTTOM_SHEET_DATA) as DialogPostsType;
    readonly bottomSheetRef = inject(MatBottomSheetRef<NandaSheetComponent>);

    public onCloseBottomSheet(): void {
        this.bottomSheetRef.dismiss();
    }

    ngOnInit(): void {}
}

type DialogPostsType = {
    company: CompanyEntity;
    report: ReportEntity;
};
